import {call, put, takeLatest} from 'redux-saga/effects';
import RewardsApi from '../../api/RewardsApi';
import rewardsActions from '../../actions/fortnite-game/rewards.actions';
import getErrorCodeFromResponse from '../../utils/errors/getErrorCodeFromResponse';
import {NO_DATA_ERROR_CODE} from './constants';

function* getRewards(action) {
    try {
        delete action.payload.silent;

        const {data} = yield call(RewardsApi.getData, action.payload);

        yield put(
            rewardsActions.getRewardsSuccess({
                data,
                error: data && data.length ? undefined : NO_DATA_ERROR_CODE
            })
        );
    } catch (e) {
        yield put(rewardsActions.getRewardsFailed(getErrorCodeFromResponse(e), e));
    }
}

function* rewardsSaga() {
    yield takeLatest(rewardsActions.TYPES.GET_REWARDS, getRewards);
}

export default rewardsSaga;
